export default __webpack_public_path__ + "static/media/g2022-22.de67ae76.jpeg";